import React from 'react'
import { FormattedMessage } from 'react-intl'

export default class IsInvalidRange {
  constructor({ allValues }) {
    this.allValues = allValues
    this.errorMessage = <FormattedMessage id="invalid_range" />
  }

  validate() {
    const {
      allValues: {
        parameters: { minRange, maxRange, min_length, max_length },
      },
    } = this

    if (min_length && max_length && +max_length <= +min_length) {
      return this.errorMessage
    }

    if (minRange && maxRange && +maxRange <= +minRange) {
      return this.errorMessage
    }

    return null
  }
}
